import { Injectable } from '@angular/core';
import { Http, RequestOptions,RequestOptionsArgs,ResponseContentType, RequestMethod ,Headers, URLSearchParams } from '@angular/http';
import { CookieClientService } from './cookieClient';
import set = Reflect.set;

@Injectable()
export class HttpClientService {
  constructor( private _http : Http, private _cookie:CookieClientService){}
  requestOpts;

  makeHttpOption(setArrayBuffer?:boolean) {
    let headers = new Headers();
    if(typeof this._cookie.getValue(btoa('authorization')) !== "undefined") headers.append('authorization',this._cookie.getValue(btoa('authorization')));
    this.requestOpts = new RequestOptions({headers});
  }

  get(url: string, params?:URLSearchParams, setArrayBuffer?:boolean) {
    this.makeHttpOption(setArrayBuffer);
    if(typeof params !== "undefined") this.requestOpts.params =params;
    if(setArrayBuffer) this.requestOpts.responseType =ResponseContentType.ArrayBuffer;

    return this._http.get(url, this.requestOpts)
  }

  multipart(url : string, data : FormData){
     this.makeHttpOption();
    return this._http.post(url, data, this.requestOpts);
  }

  post(url : string, data: any) {
    return this._http.post(url, data, this.requestOpts);
  }

  put(url: string, data: any) {
    return this._http.put(url, data, this.requestOpts);
  }

  delete(url : string) {
    return this._http.delete(url, this.requestOpts);
  }

}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/utils/http-client.module.ts